import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var l=p=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 512 512"},p),{children:jsx("path",{fill:"currentColor",d:"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"})})),s=l;

export { s as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-7P2NMP4H.mjs.map